<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="lightbox">
      <div>
        <h1>買主資料即時GET 帳號管理</h1>

        <p class="my-3">&nbsp;</p>

        <div class="alert bg-light">
          <p>• 電子名片將於線上展攤位相關頁面顯示，亦可於展期與買主進行即時文字與視訊對談。</p>
          <p>• 電子名片相關資訊可自行至展昭會員中心中的公司資料進行編輯。</p>
          <p>• 電子名片刪除後連同文字通訊紀錄一併刪除，請務必再行確定是否已備份相關資料。</p>
          <p>
            •
            電子名片之被綁定人員務必先完成展昭會員註冊，若未完成會員註冊，系統將無法進行任何綁定該名人員之電子名片，且相關功能將無法使用。
            <span>
              &thinsp;&thinsp; 以下提供會員註冊連結:<span style="color: rgb(61, 61, 61)">
                https://www.chanchao.com.tw/accounts/signup</span
              >。</span
            >
          </p>
          <p></p>
        </div>
        <div class="cardType mt-3">
          <!-- 首次進入 -->

          <div class="col-sm-6 mb-2" v-if="firstEntry">
            <div
              class="card mt-3 d-flex justify-content-center align-items-center shadow pointer"
              data-toggle="modal"
              data-target="#AddCardModal"
              style="background-color: rgb(220, 221, 219)"
            >
              <i class="fas fa-plus-circle fa-4x text-secondary"></i>
              <p class="text-secondary mt-3" style="font-size: 18px">新增一名App使用者</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 mb-2 justify-content-end" v-for="item in CardInfo">
              <div v-if="item.Verified == 1">
                <div class="card mt-3 bg-white shadow text-sm-left text-center">
                  <div class="card-header">
                    <p class="my-3">&nbsp;</p>
                  </div>
                  <div class="card-body">
                    <div class="row m-1 justify-content-between">
                      <div class="delIcon text-danger pointer" @click.prevent="DelCard(item.Email)">
                        <i class="fas fa-minus-circle" data-toggle="tooltip" data-placement="top" title="刪除"></i>
                      </div>
                      <div class="col-md-4">
                        <div class="mt-3">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${item.Logo}`"
                            width="100px"
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="col-md-8 mt-2">
                        <h3 class="mb-3">{{ item.Company }}</h3>
                        <p>{{ item.Dept }}</p>
                        <h3 class="mb-3 font-weight-bold">{{ item.Name }}</h3>
                        <p v-if="item.Address">
                          <i class="fas fa-map-marker-alt mr-1 mb-1" style="color: #6b6766"></i> {{ item.Address }}
                        </p>
                        <p v-if="item.Tel">
                          <i class="fas fa-phone-square-alt mr-1 mb-1" style="color: #6b6766"></i> {{ item.Tel }} #{{
                            item.Ext
                          }}
                        </p>
                        <p v-if="item.Email">
                          <i class="fas fa-envelope-square mr-1" style="color: #6b6766"></i> {{ item.Email }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.Verified == 0">
                <div
                  class="card mt-3 d-flex justify-content-center align-items-center shadow"
                  style="background-color: rgb(220, 221, 219)"
                >
                  <div class="delIcon text-danger pointer" @click.prevent="DelCard(item.Email)">
                    <i class="fas fa-minus-circle" data-toggle="tooltip" data-placement="top" title="刪除"></i>
                  </div>
                  <i class="fas fa-exclamation-circle fa-4x" style="color: rgb(206, 100, 96)"></i>
                  <div style="font-size: 15px" class="text-secondary text-center">
                    <p class="mt-3">
                      您輸入的信箱 <span>{{ item.Email }}</span> 尚未啟用
                    </p>
                    <p>煩請顧攤人員至信箱收信並依照指示啟用帳號</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 判定Vip層級及剩餘卡片數 -->
            <div class="col-sm-6 mb-2" v-if="!firstEntry && VisitorGetQuota > CardNum">
              <div
                class="card mt-3 d-flex justify-content-center align-items-center shadow pointer BannerHover"
                data-toggle="modal"
                data-target="#AddCardModal"
                style="background-color: rgb(220, 221, 219)"
              >
                <i class="fas fa-plus-circle fa-4x text-secondary"></i>
                <p class="text-secondary mt-3" style="font-size: 18px">新增一名App使用者</p>
              </div>
            </div>
          </div>

          <!-- 新增卡片Modal -->
          <div
            class="modal fade"
            id="AddCardModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title font-weight-bold" id="exampleModalLabel">新增帳號</h3>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p>請輸入展昭會員信箱。</p>
                  <form id="form1" @submit.prevent="AddStaffInfo">
                    <p class="formTitle mt-4">Email <span class="red">*</span></p>
                    <input
                      type="email"
                      name="ClientEmail"
                      class="textStyle maxText"
                      maxlength="50"
                      required
                      v-model="staffMail"
                    />
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal" data-bs-target="#myModal">
                    返回
                  </button>
                  <input type="submit" value="確定送出" class="btn btn-primary" @click.prevent="AddStaffInfo" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    data() {
      return {
        CSRF_Token: '',
        RegNo: '',
        staffMail: '',
        CardInfo: [],
        CardNum: '',
        firstEntry: '',
        VisitorGetQuota: '',
      }
    },

    methods: {
      DelCard(Email) {
        const vm = this
        if (confirm('請確認要刪除此App使用者嗎？')) {
          const info = {
            CSRF: vm.CSRF_Token,
            userEmail: Email,
          }
          const url = `/apiExhibitors/RemoveAppUser/${vm.RegNo}`

          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              alert('您選擇的App使用者移除成功！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetCardInfo?no=${vm.RegNo}`
            } else if (response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('信箱錯誤！')
            } else if (response.data.Code == 254) {
              alert('無該App使用者！')
            }
          })
        } else {
          return false
        }
      },

      AddStaffInfo() {
        const vm = this
        const url = `/apiExhibitors/AppUser/${vm.RegNo}`

        const info = {
          userEmail: vm.staffMail,
          CSRF: vm.CSRF_Token,
        }

        // // console.log(info)

        if (!vm.staffMail) {
          alert('輸入欄位不完整，請重新檢查！')
        } else {
          axios.post(url, info).then(function (response) {
            // console.log(response)
            if (response.data.Code == 200) {
              alert('App使用者新增成功！')
              $('#AddCardModal').modal('hide')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgradeGetCardInfo?no=${vm.RegNo}`
            } else if (response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
              $('#AddCardModal').modal('hide')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 254) {
              alert('您輸入的 Email 已被使用，請重新輸入！')
              $('#AddCardModal').modal('hide')
            } else if (response.data.Code == 253) {
              alert('新增失敗，已超過App可申請使用者數量上限！')
              $('#AddCardModal').modal('hide')
            } else if (response.data.Code == 255) {
              alert('請輸入正確的 Email！')
              $('#AddCardModal').modal('hide')
            } else if (response.data.Code == 256) {
              alert('此 Email 非展昭會員帳號，請通知該人員前往進行展昭會員註冊！')
              $('#AddCardModal').modal('hide')
            }
          })
        }
      },
    },

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]

      //取得攤位人員資料
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/AppUserList/${vm.RegNo}`).then((response) => {
        // console.log(response)
        vm.CardInfo = response.data.Data
        vm.CardNum = response.data.Data.length

        if (!vm.CardNum) {
          vm.firstEntry = true
        } else {
          vm.firstEntry = false
        }
      })

      $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })

      $(function () {
        $('#AddCardModal').on('hide.bs.modal', function () {
          vm.staffMail = ''
        })
      })

      $(function () {
        $('#EditCardModal').on('hide.bs.modal', function () {
          vm.staffMail = ''
        })
      })

      //取得使用者數量限制
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
        // console.log(response)
        vm.VisitorGetQuota = response.data.Data.VisitorGetQuota

        // console.log(vm.VisitorGetQuota)
      })
    },
  }
</script>

<style lang="scss">
  .card {
    position: relative;
    /* width: 427px;
        height: 270px; */
    width: 427px;
    min-height: 260px;
    border-radius: 0.95rem;
    border: 0px;
  }

  a:hover {
    color: #066a99;
    text-decoration: none;
  }

  .card-body {
    padding: 0.5rem;
  }

  .card-header {
    padding: 0rem 0.8rem;
    margin-bottom: 0;
    background-color: #eecf8d;
    border-bottom: 0px;
    border-radius: 0.95rem 0.95rem 0.15rem 0.15rem;
  }

  .card-header:first-child {
    border-radius: calc(0.95rem - 1px) calc(0.95rem - 1px) 0 0;
  }

  .delIcon {
    position: absolute;
    top: -19px;
    left: 410px;
    font-size: 36px;
  }

  .delIcon:hover {
    filter: brightness(1.1);
  }

  .BannerHover:hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 576px) {
    .card {
      position: relative;
      width: 280px;
      height: 325px;
      border-radius: 0.95rem;
      border: 0px;
    }
  }
</style>
